import type { SxProps, Theme } from '@mui/material';

export const styles = {
    card: (active: boolean): SxProps<Theme> => ({
        m: 0.5,
        p: 1.25,
        borderRadius: '8px',
        cursor: 'pointer',
        backgroundColor: active ? '#F0F7FF' : '#FFFFFF',
        border: active ? '1px solid #BBDBFB' : '1px solid #E2E8EE',
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
    }),
    iconBadge: (active: boolean, theme: Theme): SxProps<Theme> => ({
        flex: '0 0 44px',
        width: 44,
        height: 44,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: active ? theme.palette.white : theme.palette.grey[30],
        '& .MuiSvgIcon-root': {
            color: theme.palette.blue[700],
            fontSize: 26,
        },
    }),
    body: {
        flex: 1,
        minWidth: 0,
    } as SxProps<Theme>,
    name: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: '14px',
        color: '#141E25',
    } as SxProps<Theme>,
    services: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: '12px',
        color: '#69787F',
        mt: 0.25,
    } as SxProps<Theme>,
    locations: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: '12px',
        color: '#9AA4A9',
        mt: 0.5,
    } as SxProps<Theme>,
    pending: (theme: Theme): SxProps<Theme> => ({
        display: 'inline-block',
        mt: 0.5,
        px: 1,
        py: 0.25,
        borderRadius: '4px',
        backgroundColor: theme.palette.yellow[30],
        color: theme.palette.yellow[900],
        fontSize: '11px',
        fontWeight: 500,
    }),
};
